import { getDogfoodClient } from '@gonfalon/dogfood-client/getDogfoodClient';
import { LDRecord } from '@launchdarkly/session-replay';

// Create an object
type LDFeedbackData = {
  feedback_answer: string;
  flag_key: string;
  sentiment?: LDFeedbackSentiment;
  feedback_prompt?: string;
  slack_channel_id?: string;
  o11y_session_id?: string;
  custom_properties?: Record<string, unknown>;
};

// Ensure the provided sentiment value is valid
export type LDFeedbackSentiment = 'positive' | 'neutral' | 'negative' | null;

export async function sendFeedback({
  flagKey,
  feedback,
  sentiment,
  prompt,
  slackChannelId,
  customProperties,
  eventData,
}: {
  flagKey: string;
  feedback: string;
  sentiment?: LDFeedbackSentiment;
  prompt?: string;
  slackChannelId?: string;
  customProperties?: Record<string, unknown>;
  eventData?: Record<string, string>;
}) {
  const ldClient = getDogfoodClient();
  const feedbackData: LDFeedbackData & Record<string, unknown> = {
    ...eventData,
    feedback_answer: feedback,
    flag_key: flagKey,
    sentiment: sentiment ?? 'neutral',
  };
  // Tie the feedback to an observability session ID
  const sessionID = LDRecord.getSession()?.sessionSecureID;
  if (sessionID) {
    feedbackData.o11y_session_id = sessionID;
  }
  // The wording of the question or form prompt that generated the feedback
  if (prompt) {
    feedbackData.feedback_prompt = prompt;
  }
  if (slackChannelId) {
    feedbackData.slack_channel_id = slackChannelId;
  }
  if (customProperties) {
    feedbackData.custom_properties = customProperties;
  }

  // Send the event back to LaunchDarkly
  ldClient.track('$ld:feedback', feedbackData);
  await ldClient.flush();
}
